<span class="bv-switch__track">
  <span class="bv-switch__knob"></span>
</span>
<span class="bv-switch__label">
  <ng-content></ng-content>
</span>
